// ---------------------------------------------------------------------------
// The signed-in operator's role, shared by every view.
//
// 'admin' can change things; 'viewer' is the read-only login (VIEWER_EMAIL on
// the API). Views consult canWrite() to leave write controls out entirely
// rather than rendering them disabled — a viewer should see the data, not a
// wall of greyed-out buttons.
//
// This is presentation only. The API refuses every non-GET request from a
// viewer session (requireWriteAccess in api/src/middleware/auth.ts), so a
// tampered bundle gains nothing.
// ---------------------------------------------------------------------------

let role = 'admin';

/** Called by main.js with the session from /api/auth/login or /api/auth/me. */
export function setSessionRole(next) {
  // Anything unexpected falls to the restrictive side.
  role = next === 'admin' ? 'admin' : 'viewer';
}

export function canWrite() {
  return role === 'admin';
}
